export const SITE_URL = (
  process.env.REACT_APP_SITE_URL || 'https://oraxai.com'
).replace(/\/$/, '');
